import ExcelJS from 'exceljs'
import {
    fiatCurrencyList as fiatOptions,
    getCountries,
} from '../client/Juno/helpers'

const BULK_PAYMENT_COLUMNS = [
    { header: 'BeneficiaryName', key: 'beneficiaryName', width: 20 },
    { header: 'UniqueReference', key: 'uniqueReference', width: 20 },
    { header: 'AccountHolder', key: 'accountHolder', width: 20 },
    { header: 'Address1', key: 'address1', width: 10 },
    { header: 'Address2', key: 'address2', width: 10 },
    { header: 'City', key: 'city', width: 10 },
    { header: 'County', key: 'county', width: 20 },
    { header: 'Postcode', key: 'postcode', width: 20 },
    { header: 'Country', key: 'country', width: 20 },
    { header: 'PaymentCurrency  ', key: 'paymentCurrency', width: 20 },
    { header: 'BankName', key: 'bankName', width: 20 },
    { header: 'BankCountry', key: 'bankCountry', width: 20 },
    { header: 'AccountNumber', key: 'accountNumber', width: 20 },
    { header: 'SwiftCode', key: 'swiftCode', width: 20 },
    { header: 'IbanNumber', key: 'ibanNumber', width: 20 },
    { header: 'OtherRouting', key: 'otherRouting', width: 20 },
    { header: 'BranchCode', key: 'branchCode', width: 20 },
    { header: 'Telephone', key: 'telephone', width: 10 },
    { header: 'Email', key: 'email', width: 10 },
    { header: 'SettlementCurrency', key: 'settlementCurrency', width: 20 },
    { header: 'Reference', key: 'reference', width: 20 },
    { header: 'Amount', key: 'amount', width: 20 },
    { header: 'ArriveBy', key: 'arriveBy', width: 20 },
    { header: 'TransactionCode', key: 'transactionCode', width: 20 },
    { header: 'OwningSide', key: 'owningSide', width: 10 },
    { header: 'Method', key: 'method', width: 10 },
    { header: 'UltimateDebtorName', key: 'ultimateDebtorName', width: 20 },
    {
        header: 'UltimateDebtorIdentificationNumber',
        key: 'ultimateDebtorIdentificationNumber',
        width: 20,
    },
    {
        header: 'UltimateDebtorStreetName',
        key: 'ultimateDebtorStreetName',
        width: 20,
    },
    {
        header: 'UltimateDebtorBuildingNumber',
        key: 'ultimateDebtorBuildingNumber',
    },
    { header: 'UltimateDebtorCity', key: 'ultimateDebtorCity', width: 20 },
    {
        header: 'UltimateDebtorCountry',
        key: 'ultimateDebtorCountry',
        width: 20,
    },
    {
        header: 'UltimateDebtorPostCode',
        key: 'ultimateDebtorPostCode',
        width: 20,
    },
    { header: 'InvoiceNumber', key: 'invoiceNumber', width: 20 },
    { header: 'InvoiceDate', key: 'invoiceDate', width: 10 },
]

const generateBulkPaymentTemplate = async () => {
    try {
        const workbook = new ExcelJS.Workbook()

        // add instructions
        await addBulkInstructions(
            generateBulkHeaders(workbook.addWorksheet('Instructions'))
        )

        // generate transactions sheet
        const transactions = generateBulkHeaders(
            workbook.addWorksheet('Transactions')
        )

        // add validations
        await addBulkValidations(
            transactions,
            workbook.addWorksheet('Validations')
        )

        return workbook
    } catch (error) {
        console.error('Error generating bulk payment template:', error)
        throw new Error('Failed to generate bulk payment template')
    }
}

const generateBulkHeaders = (sheet) => {
    sheet.columns = BULK_PAYMENT_COLUMNS
    sheet.getRow(1).eachCell((cell, number) => {
        cell.font = {
            color: {
                argb: [7, 8, 5, 11, 16, 17, 18, 19, 20, 24, 25].includes(number)
                    ? 'ffffff'
                    : 'ffff00',
            },
            bold: true,
            size: 9,
            name: 'Aptos Narrow',
        }

        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
                argb: '2a6099',
            },
        }

        cell.border = {
            ...cell.border,
            right: {
                style: 'medium',
            },
        }
    })

    return sheet
}

const addBulkInstructions = async (sheet) => {
    sheet.getRow(2).getCell(1).value = 'Insert account name here'
    sheet.getRow(2).getCell(3).value = 'Insert account name here'
    sheet.getRow(2).getCell(9).value = 'GB'
    sheet.getRow(2).getCell(10).value = 'GBP'
    sheet.getRow(2).getCell(12).value = 'GB'
    sheet.getRow(2).getCell(13).value = '01234567'
    sheet.getRow(2).getCell(16).value = '012345'
    sheet.getRow(2).getCell(20).value = 'GBP'
    sheet.getRow(2).getCell(21).value = 'Optional Reference'
    sheet.getRow(2).getCell(22).value = 'Enter Payment Amount'
    sheet.getRow(6).getCell(1).value =
        'Please refer to the guidance below on how to correctly complete the payment entries, and then use the Transactions tab to enter the payments accordingly.'
    sheet.getRow(6).getCell(1).font = {
        bold: true,
    }

    sheet.getRow(2).eachCell((cell) => {
        cell.font = {
            size: 9,
            name: 'Aptos Narrow',
        }
    })

    let instructionsList = [
        [
          { "value": "TYPE", "rowHeight": 45 },
          { "value": "MANDATORY?", "rowHeight": 45 },
          { "value": "SWIFT", "rowHeight": 45 },
          { "value": "FASTER PAYMENTS", "rowHeight": 45 },
          { "value": "DESCRIPTION", "rowHeight": 45 }
        ],
        [
          { "value": "Column A: BeneficiaryName", "rowHeight": 90 },
          { "value": "Yes", "rowHeight": 90 },
          {
            "value": "Can be up to 35 characters (Combination of name and address can be up to 140 characters)",
            "rowHeight": 90
          },
          {
            "value": "Can be up to 35 characters (Combination of name and address can be up to 140 characters)",
            "rowHeight": 90
          },
          {
            "value": "The legal full name or registered company name of the individual or company",
            "rowHeight": 90
          }
        ],
        [
          { "value": "Column B: UniqueReference ", "rowHeight": 30 },
          { "value": "Leave Blank", "rowHeight": 30 },
          { "value": "Leave Blank", "rowHeight": 30 },
          { "value": "Leave Blank", "rowHeight": 30 },
          { "value": "Leave Blank", "rowHeight": 30 }
        ],
        [
          { "value": "Column C: AccountHolder ", "rowHeight": 90 },
          { "value": "Yes", "rowHeight": 90 },
          {
            "value": "Can be up to 35 characters (Combination of name and address can be up to 140 characters)",
            "rowHeight": 90
          },
          {
            "value": "Can be up to 35 characters (Combination of name and address can be up to 140 characters)",
            "rowHeight": 90
          },
          {
            "value": "The account holder name, if different from the BeneficiaryName",
            "rowHeight": 90
          }
        ],
        [
          { "value": "Column D: Address1", "rowHeight": 90 },
          { "value": "Yes", "rowHeight": 90 },
          {
            "value": "(Combination of name and address can be up to 140 characters)",
            "rowHeight": 90
          },
          {
            "value": "Can be up to 35 characters (Combination of name and address can be up to 140 characters)",
            "rowHeight": 90
          },
          { "value": "The beneficiary's address line 1", "rowHeight": 90 }
        ],
        [
          { "value": "Column E: Address2", "rowHeight": 90 },
          { "value": "Optional", "rowHeight": 90 },
          {
            "value": "(Combination of name and address can be up to 140 characters)",
            "rowHeight": 90
          },
          {
            "value": "Can be up to 35 characters (Combination of name and address can be up to 140 characters)",
            "rowHeight": 90
          },
          { "value": "The beneficiary's address line 2", "rowHeight": 90 }
        ],
        [
          { "value": "Column F: City ", "rowHeight": 90 },
          { "value": "Optional", "rowHeight": 90 },
          {
            "value": "Can be up to 35 characters (Combination of name and address can be up to 140 characters)",
            "rowHeight": 90
          },
          { "value": "Can be up to 35 characters", "rowHeight": 90 },
          { "value": "The beneficiary's city", "rowHeight": 90 }
        ],
        [
          { "value": "Column G: County", "rowHeight": 60 },
          { "value": "Optional", "rowHeight": 60 },
          {
            "value": "(Combination of name and address can be up to 140 characters)",
            "rowHeight": 60
          },
          { "value": "Can be up to 35 characters", "rowHeight": 60 },
          { "value": "The beneficiary's county", "rowHeight": 60 }
        ],
        [
          { "value": "Column H: Postcode", "rowHeight": 60 },
          { "value": "Optional", "rowHeight": 60 },
          {
            "value": "(Combination of name and address can be up to 140 characters)",
            "rowHeight": 60
          },
          { "value": "Can be up to 16 characters", "rowHeight": 60 },
          { "value": "The beneficiary's postcode", "rowHeight": 60 }
        ],
        [
          { "value": "Column I: Country", "rowHeight": 45 },
          { "value": "Yes", "rowHeight": 45 },
          {
            "value": "Must be 2 character ISO code (select from drop down)",
            "rowHeight": 45
          },
          {
            "value": "Must be 2 character ISO code  (select from drop down)",
            "rowHeight": 45
          },
          { "value": "The beneficiary's country code", "rowHeight": 45 }
        ],
        [
          { "value": "Column J: PaymentCurrency", "rowHeight": 75 },
          { "value": "Yes", "rowHeight": 75 },
          {
            "value": "Must be 3 character ISO code (select from the drop down)",
            "rowHeight": 75
          },
          { "value": "FPS=GBP  (select from drop down)", "rowHeight": 75 },
          {
            "value": "The currency you are sending to the beneficiary- Must match Settlement Currency",
            "rowHeight": 75
          }
        ],
        [
          { "value": "Column K: BankName", "rowHeight": 30 },
          { "value": "No", "rowHeight": 30 },
          { "value": "Can be up to 35 characters", "rowHeight": 30 },
          { "value": "Can be up to 35 characters", "rowHeight": 30 },
          { "value": "The beneficiary's bank name", "rowHeight": 30 }
        ],
        [
          { "value": "Column L: BankCountry", "rowHeight": 45 },
          { "value": "Yes", "rowHeight": 45 },
          {
            "value": "Must be 2 character ISO code (select from drop down)",
            "rowHeight": 45
          },
          {
            "value": "Must be 2 character ISO code  (select from drop down)",
            "rowHeight": 45
          },
          { "value": "The beneficiary's bank country", "rowHeight": 45 }
        ],
        [
          { "value": "Column M: AccountNumber", "rowHeight": 105 },
          { "value": "Conditional", "rowHeight": 105 },
          {
            "value": "Can be up to 34 characters - it if begins with a 0 please insert the following symbol '  (Click into cell M:2, for example)",
            "rowHeight": 105
          },
          {
            "value": "FPS - 8 digits-  it if begins with a 0 please insert the following symbol '  (Click into cell M:2, for example)",
            "rowHeight": 105
          },
          { "value": "The beneficiary's bank account number", "rowHeight": 105 }
        ],
        [
          { "value": "Column N: SwiftCode", "rowHeight": 30 },
          { "value": "Conditional", "rowHeight": 30 },
          { "value": "Can be up to 11 characters", "rowHeight": 30 },
          { "value": "Can be up to 11 characters", "rowHeight": 30 },
          { "value": "The beneficiary's 8 or 11 digit BIC", "rowHeight": 30 }
        ],
        [
          { "value": "Column O: IbanNumber", "rowHeight": 45 },
          { "value": "Conditional", "rowHeight": 45 },
          { "value": "Can be up to 34 characters", "rowHeight": 45 },
          { "value": "Can be up to 34 characters", "rowHeight": 45 },
          {
            "value": "The beneficiary's IBAN. The checksum is validated",
            "rowHeight": 45
          }
        ],
        [
          { "value": "" },
          { "value": "" },
          { "value": "" },
          { "value": "FPS - optional" },
          { "value": "" }
        ],
        [
          { "value": "Column P: OtherRouting/Sort code", "rowHeight": 105 },
          { "value": "Conditional", "rowHeight": 105 },
          {
            "value": "Dependent on type of other routing: it if begins with a 0 please insert the following symbol '  (Click into cell M:2, for example)",
            "rowHeight": 105
          },
          {
            "value": "FPS - 6 digit (sort code) -it if begins with a 0 please insert the following symbol '  (Click into cell M:2, for example)",
            "rowHeight": 105
          },
          {
            "value": "The beneficiary's bank code or routing code.",
            "rowHeight": 105
          }
        ],
        [
          { "value": "", "rowHeight": 30 },
          { "value": "", "rowHeight": 30 },
          { "value": "Intermediary BIC (8-11)", "rowHeight": 30 },
          { "value": "", "rowHeight": 30 },
          { "value": "", "rowHeight": 30 }
        ],
        [
          { "value": "" },
          { "value": "" },
          { "value": "Sort code (8)" },
          { "value": "" },
          { "value": "" }
        ],
        [
          { "value": "" },
          { "value": "" },
          { "value": "ACH (9)" },
          { "value": "" },
          { "value": "" }
        ],
        [
          { "value": "Column Q: BranchCode", "rowHeight": 45 },
          { "value": "Conditional", "rowHeight": 45 },
          { "value": "Can be up to 12 characters", "rowHeight": 45 },
          { "value": "Can be up to 35 characters", "rowHeight": 45 },
          {
            "value": "The beneficiary's bank branch code or routing code",
            "rowHeight": 45
          }
        ],
        [
          { "value": "Column R: Telephone", "rowHeight": 75 },
          { "value": "Conditional", "rowHeight": 75 },
          {
            "value": "(Combination of reference, email and telephone can be up to 140 characters)",
            "rowHeight": 75
          },
          {
            "value": "(Combination of reference, email and telephone can be up to 140 characters)",
            "rowHeight": 75
          },
          { "value": "The beneficiary's telephone number", "rowHeight": 75 }
        ],
        [
          { "value": "Column S: Email" },
          { "value": "Leave Blank" },
          { "value": "Leave Blank" },
          { "value": "Leave Blank" },
          { "value": "Leave Blank" }
        ],
        [
          { "value": "Column T: SettlementCurrency", "rowHeight": 60 },
          { "value": "Yes", "rowHeight": 60 },
          {
            "value": "Must be 3 character ISO code (select from the drop down)",
            "rowHeight": 60
          },
          {
            "value": "Must be 3 character ISO code (select from the drop down)",
            "rowHeight": 60
          },
          {
            "value": "The currency you will be debited- Must match Payment Currency",
            "rowHeight": 60
          }
        ],
        [
          { "value": "Column U: Reference", "rowHeight": 150 },
          { "value": "Yes", "rowHeight": 150 },
          {
            "value": "(Combination of reference, email and telephone can be up to 140 characters) Acceptable characters are numbers, letters, space and / - ? : ( ) . , ' +",
            "rowHeight": 150
          },
          {
            "value": "(Combination of reference, email and telephone can be up to 140 characters) Acceptable characters are numbers, letters, space and / - ? : ( ) . , ' +",
            "rowHeight": 150
          },
          {
            "value": "The payment reference, to be displayed on the beneficiary's statement",
            "rowHeight": 150
          }
        ],
        [
          { "value": "Column V: Amount", "rowHeight": 30 },
          { "value": "Yes", "rowHeight": 30 },
          { "value": "Must be a positive decimal number", "rowHeight": 30 },
          { "value": "Must be a positive decimal number", "rowHeight": 30 },
          { "value": "The payment amount", "rowHeight": 30 }
        ],
        [
          { "value": "Column W-Z:", "rowHeight": 30 },
          { "value": "Leave blank", "rowHeight": 30 },
          { "value": "Leave blank", "rowHeight": 30 },
          { "value": "Leave blank", "rowHeight": 30 },
          { "value": "Leave blank", "rowHeight": 30 }
        ],
        [
          { "value": "Column AA- AG: UltimateDebtor Information", "rowHeight": 58.5 },
          { "value": "Leave Blank", "rowHeight": 58.5 },
          { "value": "Leave Blank", "rowHeight": 58.5 },
          { "value": "Leave Blank", "rowHeight": 58.5 },
          { "value": "Leave Blank", "rowHeight": 58.5 }
        ],
        [
          { "value": "Column AH: InvoiceNumber", "rowHeight": 75 },
          { "value": "Conditional", "rowHeight": 75 },
          { "value": "Up to 12 characters", "rowHeight": 75 },
          { "value": "Up to 12 characters", "rowHeight": 75 },
          {
            "value": "The invoice number, required for some countries where the payment is fulfilling an invoice",
            "rowHeight": 75
          }
        ],
        [
          { "value": "Column AI: InvoiceDate", "rowHeight": 75 },
          { "value": "Optional", "rowHeight": 75 },
          {
            "value": "Can be up to 10 (Preferably in “DD/MM/YYYY” format)",
            "rowHeight": 75
          },
          {
            "value": "Can be up to 10 (Preferably in “DD/MM/YYYY” format)",
            "rowHeight": 75
          },
          {
            "value": "The invoice date, required for some countries where the payment is fulfilling an invoice",
            "rowHeight": 75
          }
        ]
      ]
      

    let startRow = 8
    for (let instructions of instructionsList) {
        for (let i = 0; i < instructions.length; i++) {
            let row = sheet.getRow(startRow);
            let cell = row.getCell(i + 1)
            cell.value = instructions[i].value
            if(instructions[i].rowHeight) {
                row.height = instructions[i].rowHeight;
            }
            cell.style = {
                font: { name: 'Aptos Narrow', size: 11, bold: startRow == 8 || i == 0  },
                fill: { type: 'pattern' },
                border: {
                    top: { style: 'thin', color: { indexed: 64 } },
                    left: { style: 'thin', color: { indexed: 64 } },
                    bottom: { style: 'thin', color: { indexed: 64 } },
                    right: { style: 'thin', color: { indexed: 64 } },
                },
                alignment: { wrapText: true },
            }
        }
        sheet.getColumn(startRow - 7).width = 20;
        startRow++
    }

    return sheet.protect(null, {
        selectLockedCells: true,
        selectUnlockedCells: true,
        formatCells: false,
        formatColumns: false,
        formatRows: false,
        insertColumns: false,
        insertRows: false,
        insertHyperlinks: false,
        deleteColumns: false,
        deleteRows: false,
        sort: false,
        autoFilter: false,
        pivotTables: false,
    })
}

const addBulkValidations = async (sheet, validationSheet) => {
    // dump valid values in validation sheet
    validationSheet.state = 'veryHidden'
    validationSheet.addRow(['Valid currencies', 'Valid countries'])
    fiatOptions.forEach((fiat, index) => {
        validationSheet.getRow(index + 2).getCell(1).value = fiat.text
    })

    const countries = await getCountries()
    countries
        .sort((a, b) => a.code.localeCompare(b.code))
        .forEach(
            (country, index) =>
                (validationSheet.getCell(`B${index + 2}`).value = country.code)
        )

    const countryValidation = (field) => ({
        type: 'list',
        formulae: [`Validations!$B$2:$B$${countries.length + 1}`],
        errorStyle: 'error',
        errorTitle: `Invalid Country Selected for ${field}`,
        error: 'Please select a valid country from the dropdown.',
        showInputMessage: true,
        showErrorMessage: true,
        allowBlank: true,
    })

    const currencyValidation = () => ({
        type: 'list',
        formulae: [`Validations!$A$2:$A$${fiatOptions.length + 1}`],
        allowBlank: false,
        errorStyle: 'error',
        errorTitle: `Invalid currency selected`,
        error: 'Please select a valid currency from the dropdown.',
        showInputMessage: true,
        showErrorMessage: true,
    })

    const validationList = [
        {
            cell: 'J',
            validator: currencyValidation,
        },
        {
            cell: 'T',
            validator: currencyValidation,
        },
        {
            cell: 'I',
            validator: countryValidation,
            field: 'Country',
        },
        {
            cell: 'L',
            validator: countryValidation,
            field: 'BankCountry',
        },
    ]

    // hook all the validations
    validationList.forEach(({ cell, validator, field }) => {
        for (let i = 2; i < 100; i++) {
            sheet.getCell(`${cell}${i}`).dataValidation = validator(field)
        }
    })
}

const downloadFile = async (workbook, name) => {
    try {
        const buffer = await workbook.xlsx.writeBuffer()
        //create blob
        const blob = new window.Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })

        const url = window.URL.createObjectURL(blob)
        const aTag = document.createElement('a')
        aTag.href = url
        aTag.download = `${name}.xlsx`
        aTag.click()

        window.URL.revokeObjectURL(url)
    } catch (error) {
        console.error('Error downloading file:', error)
        throw new Error('Failed to download Excel file')
    }
}

export { generateBulkPaymentTemplate, downloadFile }
